import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';

import { selectPremiumCourses } from '../../../../store/selectors/courses';
import { PROD_API } from '../../../../constants/api';

import PremiumCourses from './PremiumCourses';
import { selectAdminSubscriptionSelectedUser } from '../../../../store/selectors/app';
import useMediaQuery from '../../../../utils/breakpoints/useMediaQuery';
import { useDeleteUser } from '../../../../hooks/useDeleteUser';
import { getAllUsers } from '../../../../store/actions/userActions';
import { setAdminSubscriptionSelectedUser } from '../../../../store/actions/appActions';
import { Button } from '../../../UI/Button';

import {
   SubscriptionsUsersWrapper,
   UserSectionTitle,
   SubscriptionsUserSectionWrapper,
   ControlWrapper,
   UserControlTitle,
   UserInfoRow,
   UserImage,
   UserInfoSubWrapper,
   ControlSubtitle
} from './styled'
import EmptyPlaceholder from './EmptyPlaceholder';

export const UsersInfo = () => {
   const dispatch = useDispatch();
   const allPremiumCourses = useSelector(selectPremiumCourses);
   const selectedAdminSubscriptionUser = useSelector(selectAdminSubscriptionSelectedUser)
   const { isMobile } = useMediaQuery();
   const { enqueueSnackbar } = useSnackbar();
   const deleteUserMutation = useDeleteUser();

   console.log(selectedAdminSubscriptionUser)

   const handleDeleteUser = () => {
      if (!selectedAdminSubscriptionUser?.id) return;

      // eslint-disable-next-line no-alert
      const confirmDelete = window.confirm(
         `Вы уверены, что хотите удалить пользователя ${selectedAdminSubscriptionUser.name}? Это действие нельзя отменить.`
      );

      if (confirmDelete) {
         deleteUserMutation.mutate(
            { userId: selectedAdminSubscriptionUser.id },
            {
               onSuccess: () => {
                  enqueueSnackbar('Пользователь успешно удален', { variant: 'success' });
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  dispatch(setAdminSubscriptionSelectedUser({ user: null as any }));
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  dispatch(getAllUsers() as any);
               },
               // eslint-disable-next-line @typescript-eslint/no-explicit-any
               onError: (error: any) => {
                  enqueueSnackbar(
                     error?.message || 'Ошибка при удалении пользователя',
                     { variant: 'error' }
                  );
               },
            }
         );
      }
   };

   return <SubscriptionsUserSectionWrapper isMobile={isMobile}>
      <UserSectionTitle>Управление подпиской</UserSectionTitle>
      {selectedAdminSubscriptionUser ? <SubscriptionsUsersWrapper>
         <UserInfoRow>
            <UserInfoSubWrapper>
               <div>
                  <h1>{selectedAdminSubscriptionUser?.name}</h1>
               </div>
               <span>
                  <p>@{selectedAdminSubscriptionUser?.username} | {selectedAdminSubscriptionUser?.email}</p>
               </span>
            </UserInfoSubWrapper>
            <UserImage src={`${PROD_API}/${selectedAdminSubscriptionUser?.profile_image}`} alt="user" />
         </UserInfoRow>
         <ControlWrapper>
            <UserControlTitle>Текущие курсы пользователя</UserControlTitle>
            <ControlSubtitle>Курсы выделенные галочкой являются активными для пользователя</ControlSubtitle>
            <PremiumCourses premiumCourses={allPremiumCourses} />
         </ControlWrapper>
         <ControlWrapper style={{ marginTop: '20px' }}>
            <Button
               modifier="primary"
               onClick={handleDeleteUser}
               disabled={deleteUserMutation.isLoading}
               color='Art-therapy'
            >
               {deleteUserMutation.isLoading ? 'Удаление...' : 'Удалить пользователя'}
            </Button>
         </ControlWrapper>
      </SubscriptionsUsersWrapper> : <EmptyPlaceholder />}
   </SubscriptionsUserSectionWrapper>
}